import { useContext, useEffect, useRef, useState } from "react";
import CustomButton from "/components/core/ButtonDefault";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, EffectFade } from "swiper/modules";
import { useAnimation } from "/context/AnimationProvider";
import { ScrollBar } from "/utils/ScrollBarFactory";
import useAxiosREST from "/utils/hooks/useAxiosAPI";
import AuthContext from "/context/AuthProvider";
import state from "/redux/state";

// import SwiperCore from "swiper";
import { Scrollbar } from "swiper/modules";

// SwiperCore.use([Scrollbar]);

const tabs = [
  {
    name: "Media",
    key: "media",
    component: DualSlider,
  },
  {
    name: "How To Play",
    key: "how-to-play",
    component: HowToPlay,
  },
];

export default function Introducing({ tournament, isEnded }) {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const { isMobile } = useAnimation();
  const { fetchAPI } = useAxiosREST();
  const { auth } = useContext(AuthContext);
  const generatedLink = useRef(null);
  const wrapperRef = useRef(null);

  const getTournament = async () => {
    // if (isEnded) {
    //   window.open(
    //     "https://funtico.com/games/golazo-league/compete-2-win/tournaments",
    //     "_blank"
    //   );
    //   return;
    // }

    if (!auth?.token) {
      state.setPopUp("login");
      return;
    }
    let link = generatedLink.current;

    if (!link) {
      const gameId = tournament?.gameId ?? 182;
      const data = await fetchAPI.post("/generate-game-link", { gameId });
      link = data.link;
    }
    if (link) {
      generatedLink.current = link;
      window.open(link, "_blank");
    }
  };

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper || isMobile) return;

    let sto = null;
    const resize = new ResizeObserver(() => {
      wrapper.removeAttribute("style");
      clearTimeout(sto);
      sto = setTimeout(() => {
        const child = wrapper.children[0];
        const wrapperHeight = child.clientHeight;
        wrapper.style.height = wrapperHeight + "px";
      }, 100);
    });
    resize.observe(wrapper);

    return () => {
      wrapper && wrapper.removeAttribute("style");
      resize.disconnect();
    };
  }, [isMobile]);

  return (
    <section className="introducing">
      <div className="wrapper df ai-c pd-lr-md">
        <div className={`wrapper-content df fd-c ai-c`}>
          <p className="title kanit-black">WHAT ARE WE PLAYING?</p>
          <div className="icon df">
            <img src="/introducing.png" alt="" />
          </div>
          <div className="content text-shadow">
            <p className="top">
              Feel the energy of the chanting crowds in Golazo League,
              <br />
              an exciting merge drop game created with love
              <br />
              for all the football fans & supporters out there!
            </p>
          </div>
          <CustomButton
            classname="cta-play pr"
            def={40}
            title={"PLAY NOW"}
            onClick={getTournament}
          />
        </div>
        <div className="wrapper-instruction df fd-c">
          <div className="tabs w-full df fixel_16_sbl">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={`tab ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.name}
              </button>
            ))}
          </div>
          <div className="component " ref={wrapperRef}>
            {tabs.map((tab) => (
              <tab.component
                key={tab.key}
                isMobile={isMobile}
                active={activeTab === tab.key}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function DualSlider({ active, isMobile }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const videoMainRef = useRef(null);
  const containerRef = useRef(null);
  const media = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
  const video = "/league_media/golazo_trailer.mp4";
  const screen = "/league_media/golazo_trailer_screen.jpg";
  const format = "jpg"; // "webp" | "png" | "jpg"

  useEffect(() => {
    const block = containerRef.current;

    const trigger = ScrollTrigger.create({
      trigger: block,
      start: "top 90%",
      end: "bottom 10%",
      // markers: true,
      onToggle: (self) => {
        const video = videoMainRef.current;
        if (!video) return;
        self.isActive ? video?.play() : video?.pause();
      },
    });

    return () => {
      trigger.kill();
    };
  }, [containerRef.current]);

  const mediaSlides = media.map((src) => (
    <SwiperSlide key={src} className="cover">
      <img src={`/league_media/${format}/${src}.${format}`} />
    </SwiperSlide>
  ));

  return (
    <div className={`dual-slider ${active ? "active" : ""}`} ref={containerRef}>
      {/* Main Slider */}
      <Swiper
        spaceBetween={10}
        modules={[Thumbs, EffectFade, Scrollbar]}
        slidesPerView={1}
        thumbs={{ swiper: thumbsSwiper }}
        className="swiper-main"
        // effect="fade"
        onSlideChange={(swiper) => {
          const index = swiper.activeIndex;
          const video = videoMainRef.current;
          if (thumbsSwiper) {
            thumbsSwiper.slideTo(index);
          }
          if (index === 0) {
            video?.play();
          } else {
            video?.pause();
          }
        }}
      >
        <SwiperSlide key="video" className="cover">
          <video
            loop
            muted
            ref={videoMainRef}
            controls
            playsInline
            disablePictureInPicture
          >
            <source src={video} type="video/mp4" />
          </video>
        </SwiperSlide>
        {mediaSlides}
      </Swiper>

      {/* Thumbnail Slider */}
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={20}
        slidesPerView={"auto"}
        modules={[Thumbs]}
        className="swiper-thumbs"
        scrollbar={{
          draggable: true,
        }}
      >
        <SwiperSlide className="cover">
          <div className="icon_play icon-40"></div>
          <img src={screen} />
        </SwiperSlide>
        {mediaSlides}
      </Swiper>
    </div>
  );
}

function HowToPlay({ isMobile, active }) {
  const scrollerRef = useRef(null);

  useEffect(() => {
    const block = scrollerRef.current;
    if (isMobile || !block) return;

    let scroll = null;
    setTimeout(() => {
      scroll = ScrollBar.create({ scroller: block });
    }, 2000);

    return () => {
      scroll?.kill();
    };
  }, [isMobile]);

  return (
    <div className={`how-to-play df ${active ? "active" : ""}`}>
      <div
        className="scroller df fd-c w-full"
        data-prevent-observer
        ref={scrollerRef}
      >
        <div className="row df fd-c">
          <div className="text">
            <p className="font-20">
              <strong>Ball Control</strong>
            </p>
            <p>
              Droppable balls appear in the same place at the start of the game
              and after each subsequent drop.
            </p>
            <ul>
              <li>
                You can choose where to drop the ball by moving the cursor left
                and right.
              </li>
              <li>When you're done aiming, simply left-click/tap.</li>
              <li>
                Identical balls will merge into different larger ones upon
                touching.
              </li>
            </ul>
          </div>

          <img
            src="/league_media/how-to-play/screenshot_1.png"
            alt="Ball Control"
            className="w-full"
          />
        </div>
        <div>
          <p className="font-20">
            <strong>Ball Points</strong>
          </p>
          <p>
            There are 11 types of different balls. Each merged ball gives a
            certain number of point.
          </p>
          <p>The final ball (11), can not be merged with another one.</p>
          <br />
          <img
            src="/league_media/how-to-play/screenshot_2.png"
            alt="Ball Points"
          />
        </div>
        <div>
          <p className="font-20">
            <strong>Game Time & Counting</strong>
          </p>
          <p>
            Collect as many points as possible by spending the least amount of
            time.
          </p>
          <ul>
            <li>The session time is shown at the bottom of the game screen.</li>
            <li>Ball merging combos offer more points.</li>
          </ul>
          <img
            src="/league_media/how-to-play/screenshot_3.png"
            alt="Game Time & Counting"
          />
        </div>
        <div>
          <p className="font-20">
            <strong>Energy Bar</strong>
          </p>
          <br />
          <img
            src="/league_media/how-to-play/screenshot_4.png"
            alt="Energy Bar"
          />
          <p>Energy is required to drop balls into the net.</p>
          <ul>
            <li>Each ball drop consumes one Energy Slot.</li>
            <li>
              Energy Slots regenerate automatically and independently over time.
            </li>
            <li>You cannot drop balls when the Energy Bar is depleted.</li>
            <li>
              Collect extra Energy rewards to permanently increase your maximum
              Energy Slots up to a limit.
            </li>
            <li>
              Use the Energy Boost Power-Up for unlimited drops for a limited
              time.
            </li>
          </ul>
        </div>

        <div>
          <p className="font-20">
            <strong>Power-Ups</strong>
          </p>
          <p>Collect and use Power-Ups for tactical advantages.</p>
          <ul>
            <li>Obtained by merging reward balls.</li>
            <li>Storage is limited for each Power-Up.</li>
            <li>Activate by clicking the Power-Up icon.</li>
          </ul>
        </div>
        <div>
          <p className="font-20">
            <strong>Available Power-Ups:</strong>
          </p>
          <br />

          <img
            src="/league_media/how-to-play/screenshot_5.png"
            alt="Energy Bar"
          />

          <ul>
            <li>
              <strong>REMOVE BALL</strong>: select and remove any single ball
              from the net.
            </li>
            <li>
              <strong>INCREASE BALL</strong>: select and upgrade any ball to the
              next tier.
            </li>
            <li>
              <strong>REMOVE SMALL BALLS</strong>: instantly removes all
              low-tier balls from the net.
            </li>
            <li>
              <strong>ENERGY BOOST</strong>: grants unlimited drops for a
              limited time - no energy consumed.
            </li>
          </ul>
        </div>

        <div>
          <p className="font-20">
            <strong>Merge Rewards</strong>
          </p>

          <p>Some balls contain special rewards that activate when merged.</p>

          <ul>
            <li>Reward balls display a reward icon over them. </li>
            <li>
              When such ball becomes part of a merge, the reward is activated
              instantly.
            </li>
          </ul>

          <img
            src="/league_media/how-to-play/screenshot_6.png"
            alt="Merge Rewards"
          />
        </div>

        <div>
          <p className="font-20">
            <strong>Reward Types:</strong>
          </p>

          <ul>
            <li>
              <strong>BONUS POINTS</strong>: instantly added to your score.
            </li>
            <li>
              <strong>POWER-UPS</strong>: collected as Power-Ups usages up to a
              maximum limit.
            </li>
            <li>
              <strong>EXTRA ENERGY</strong>: permanently adds an additional
              energy slot.
            </li>
          </ul>
        </div>
        <div>
          <p className="fixel_36 text-center">GL & HF!</p>
        </div>
      </div>
    </div>
  );
}
